import React from "react";
type SectionHeadingProps = {
  kicker?: string;
  title: string;
  intro?: string[];
  dark?: boolean;
};
export function SectionHeading({
  kicker,
  title,
  intro,
  dark = false
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-84" data-mp="3f25c14r7ckko">
      {kicker && <p className={`font-display text-base font-bold uppercase tracking-[0.12em] sm:text-lg ${dark ? "text-electric-light" : "text-electric"}`} data-id="element-85" data-mp="3jzx7u9uywqu5">
          {kicker}
        </p>}
      <h2 className={`mt-2 font-display text-4xl font-extrabold uppercase leading-[1] sm:text-5xl lg:text-6xl ${dark ? "text-white" : "text-ink"}`} data-id="element-86" data-mp="gif002f73jtq">
        {title}
      </h2>
      {intro && <div className={`mt-5 space-y-3 text-base sm:text-lg ${dark ? "text-white/75" : "text-muted"}`} data-id="element-87" data-mp="6rk9umytw030">
          {intro.map(p => <p key={p} data-id="element-88" data-mp="zahi7i7hj863">{p}</p>)}
        </div>}
    </div>;
}